import AvoFilterController from './avo_filter_controller'
import AvoFiltersController from './avo_filters_controller'
import DateFilterController from './date_filter_controller'
import TagsFilterController from './tags_filter_controller'

const application = window.Stimulus

application.register('avo-filters', AvoFiltersController)
application.register('avo-filter', AvoFilterController)
application.register('date-filter', DateFilterController)
application.register('tags-filter', TagsFilterController)
